export enum COOKIES {
    RGID = 'rgid', // регион пользователя
}
